import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService, LocalStorageService, LoginService, SharedService, ToasterService, ValidationService } from '../../../../services';
import { LocalStorage, Paths } from '../../../../enums';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnDestroy {

  isSubmitting = false;
  isSubmittingSubscription = new Subscription;
  loginForm: FormGroup;
  loginFormValidationMessage: any = [];
  previousUrl: any;
  fireBaseToken: any;
  showPassword: boolean = false;
  routerPath: string = '0';
  // currentUrl: any | null = null || undefined;

  /**
   * This method is called once, just before the component is build.
   * In this method we initialize form group  with form control. Add the validation based on form control.
   * 
   * @param sharedService 
   * @param validationService 
   * @param userServiceProxy 
   * @param toasterService 
   * @param router 
   * 
   * @memberof LoginComponent
   */
  constructor(
    private sharedService: SharedService,
    private validationService: ValidationService,
    private loginService: LoginService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private toasterService: ToasterService,
    private router: Router
  ) {
    this.loginForm = new FormGroup({
      emailId: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(20)])
    });
    this.loginFormValidationMessage["emailId"] = {
      'required': 'Email address is required.'
    };
    this.loginFormValidationMessage["password"] = {
      'required': 'Password is required.',
      'minlength': 'Password minimum 6 character required.',
      'maxlength': 'Password maximum 20 character required.'
    };

    this.isSubmittingSubscription = this.sharedService.getApiCall().subscribe((flag: any) => {
      this.isSubmitting = flag;
    });
  }

  /**
   * This method is called once, just before the component is destroyed.
   * It cleans up the subscription to prevent memory leaks.
   * 
   * @memberof LoginComponent
   */
  ngOnDestroy(): void {
    this.isSubmittingSubscription.unsubscribe();
  }

  /**
   * A getter to access the form controls of the forgot password form group.
   * 
   * @memberof LoginComponent
   */
  get f(): any {
    return this.loginForm.controls;
  }

  /**
   * Retrieves the error message for a specified form field using the validation service.
   * 
   * @param {any} fieldName - The name of the form field.
   * @returns {string} The error message for the specified form field.
   * 
   * @memberof LoginComponent
   */
  getFormErrorMessage(fieldName: any) {
    return this.validationService.getFormErrorMessage(fieldName, this.loginFormValidationMessage);
  }

  /**
   * Determines the input type for a specified form field using the validation service.
   * 
   * @param {any} fieldName - The name of the form field.
   * @returns {'primary' | 'primaryWithoutBorder' | 'secondary' | 'secondaryWithoutBorder' | 'warning' | 'warningWithoutBorder' | 'success' | 'successWithoutBorder' | 'error' | 'errorWithoutBorder'} The input type for the specified form field.
   * 
   * @memberof LoginComponent
   */
  getFormInputType(fieldName: any): 'primary' | 'primaryWithoutBorder' | 'secondary' | 'secondaryWithoutBorder' | 'warning' | 'warningWithoutBorder' | 'success' | 'successWithoutBorder' | 'error' | 'errorWithoutBorder' {
    return this.validationService.getFormInputType(fieldName, 'secondary');
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }

  /**
   * Handles the form submit event.
   * If the form is valid and not currently submitting. It sets the API call flag to true.
   * It creates SignInInput object with the data and sends it to the respective service proxy method.
   * It also handles the service proxy method response and display a message accordingly with Success or Error
   * 
   * @memberof LoginComponent
   */
  async onSubmit() {
    if (this.loginForm.valid && !this.isSubmitting) {
      this.sharedService.setApiCall(true);
      const body: any = {
        emailId: this.loginForm.get('emailId')?.value,
        password: this.loginForm.get('password')?.value
      };
      const response: any = await this.loginService.login(body);
      this.commonService.resetAPIFlag(await this.loginService.login(body, true), false);
      this.sharedService.setApiCall(false);

      switch (response.status) {
        case 1:
          if (response.user) {
            localStorage.setItem('loginData', JSON.stringify(response.user));
            this.localStorageService.setData(LocalStorage.accessToken, response.token);
            this.localStorageService.setData(LocalStorage.loginData, JSON.stringify(response.user));
            this.router.navigate(["/" + Paths.admin + "/" + Paths.dashboard]);
          }
          else {
            this.toasterService.toastSuccess(response.message);
          }
          break;
        case 0:
          this.toasterService.toastError(response.message);
          break;
      }
    }
  }
  passwordForget() {
    // this.router.navigate(["/" + Paths.forgetpassword]);
  }

  homePage(){
    this.router.navigate(["/"]);
  }
}
